import { sentryService } from '@/services/SentryService';
angular.module('leanlaw').controller('TrustReportCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$window', '$state', "alerts", 'userService', 'reportsService', "exportJson", "singleRequest", "objectNumberManipulator", "messageBus", function ($scope, $rootScope, $q, $filter, $timeout, $window, $state, alerts, userService, reportsService, exportJson, singleRequest, objectNumberManipulator, messageBus) {
  let wipReport = null;
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    $window.print();
  };
  $scope.export = function () {
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      let responsible = $scope.filter.include.matters && c.matters.length ? '' : c.responsibles.map(a => a.initials || a.name).join('\n');
      let data = line(c, c.client.reference, c.client.name, "", "", responsible);
      accum.push(data);
      if ($scope.filter.include && $scope.filter.include.matters) {
        if ($scope.references) {
          c.matters.forEach(m => {
            responsible = $scope.filter.include.matters && c.matters.length ? '' : m.responsibles.map(a => a.initials || a.name).join('\n');
            data = line(m, "", "", m.matter.name, m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '', responsible);
            accum.push(data);
          });
        } else {
          c.matters.forEach(m => {
            responsible = $scope.filter.include.matters && c.matters.length ? '' : m.responsibles.map(a => a.initials || a.name).join('\n');
            data = line(m, "", "", m.matter.name, "", responsible);
            accum.push(data);
          });
        }
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
    function line(item, ref, client, matter, matterRef, responsible) {
      const matterLabel = $scope.me.terms.Matter;
      let data = {};
      if ($scope.filter.include && $scope.filter.include.matters) {
        data = {
          "ID": matter ? matterRef : ref,
          Client: client,
          [matterLabel]: matter ? matter : "",
          Responsible: responsible
        };
      } else {
        data = {
          "ID": ref,
          Client: client,
          Responsible: responsible
        };
      }
      if ($scope.multipleTrust && item.trustAccount) {
        data["Trust Account"] = item.trustAccount.label;
      }
      if ($scope.showEvergreen) {
        data["Evergreen"] = $filter("amount")(item.evergreen);
      }
      data["Trust Balance"] = $filter("amount")(item.balance);
      data["Ready to Bill"] = item.data ? $filter("amount")(item.data.amounts.total) : '-';
      data["WIP / Trust"] = $filter("percentage")(item.wipRatio);
      data["Account Balance"] = item.data && item.data.accounting ? $filter("amount")(item.data.accounting.balance) : '-';
      if ($scope.showEvergreen && $scope.filter.include.replenish) {
        data["Replenishment"] = item.replenish ? $filter("amount")(item.replenish) : '-';
        data["Total Due"] = item.due ? $filter("amount")(item.due) : '-';
      }
      return data;
    }
  };
  $scope.loading = true;

  // Not inside userService.me(): the sidebar broadcasts its filter on its first digest with no
  // handshake, and on a cold page load that lands before me() resolves, losing filter.include
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    $scope.filter = Object.assign($scope.filter, payload);

    // Recalculate totals (because we might hide and show zeros)
    calculateTotals();
  });
  userService.me().then(me => {
    $scope.trust = me.company.settings.trustEnabled;
    // The company setting, not the rows, so narrowing the filter (say, to Originating) can't hide the evergreen
    // columns; only the sidebar's Replenishment toggle hides Replenishment and Total Due
    $scope.showEvergreen = !!me.company.settings.trust?.evergreen;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      // if (payload.filter.range) filterClientEntries();
      filterClientEntries();
    });
    $scope.$watch('filter.include.accounting', show => {
      if (show) {
        filterClientEntries();
      }
    }, true);

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
    messageBus.addMessage("clientmatter-set", true, {});
  });
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("trust-report");
    singleRequest.cancel("trust-wip");
    deactivate();
  });
  function calculateTotals() {
    if (!$scope.data) return;
    let {
      clients
    } = $scope.data;
    const {
      trustAccount,
      include
    } = $scope.filter || {};
    if (!include?.zeros) {
      clients = clients.filter(c => c.balance);
    }
    if (trustAccount != null && trustAccount.id != null) {
      clients = clients.filter(c => c.trustAccount.id === trustAccount.id);
    }
    $scope.data.balance = clients.reduce((sum, c) => sum + (c.balance || 0), 0);
    if ($scope.showEvergreen) {
      $scope.data.evergreen = clients.reduce((sum, c) => sum + (c.evergreen || 0), 0);
      $scope.data.replenish = clients.reduce((sum, c) => sum + (c.replenish || 0), 0);
    }

    // Left unset until WIP lands, so the footer stays blank rather than showing a $0.00 that reads as real
    if (!$scope.wipLoaded) return;
    $scope.data.accountBalance = clients.reduce((sum, c) => sum + (c.data.accounting.balance || 0), 0);
    $scope.data.wip = clients.reduce((sum, c) => sum + (c.data.amounts.total || 0), 0);
    $scope.data.due = clients.reduce((sum, c) => sum + (c.due || 0), 0);
    if ($scope.data.wip) {
      $scope.data.wipRatio = Math.min(Math.round($scope.data.balance * 100 / $scope.data.wip), 100);
    }
  }
  function filterClientEntries() {
    $scope.loading = true;
    // Separate from loadingWip: the WIP cells stay blank until a merge, not just until the call settles
    $scope.wipLoaded = false;
    $scope.data = null;
    const query = reportsService.queryFromFilter($scope.filter);
    $q.when(singleRequest.apiCall("trust-report", true).listAccountingTrust(query)).then(trust => {
      if (!trust) return;
      loadTrust(trust);
      calculateTotals();
      $scope.loading = false;
      mergeWip();
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });

    // WIP is the slow call, so the trust columns render without it and the WIP columns fill in
    loadWip();
  }
  function loadWip() {
    $scope.loadingWip = true;
    $scope.wipFailed = false;
    wipReport = null;
    const wipQuery = reportsService.queryFromFilter($scope.filter);
    wipQuery.primary = 'clients';
    wipQuery.startDate = undefined;
    wipQuery.endDate = undefined;
    wipQuery.billed = 'false';
    wipQuery.billedState = undefined;
    wipQuery.data = 'services,expenses,charges,receivables';
    $q.when(singleRequest.apiCall("trust-wip", true).getReport(wipQuery)).then(wip => {
      if (!wip) return;
      wipReport = wip;
      $scope.loadingWip = false;
      mergeWip();
    }).catch(() => {
      // Shown inline above the table instead of a toast: it has to outlast the toast's 5s,
      // and the trust call's own toast already covers a shared outage
      $scope.loadingWip = false;
      $scope.wipFailed = true;
    });
  }
  $scope.retryWip = loadWip;
  function loadTrust(trust) {
    $scope.multipleTrust = trust.accounts.length > 1;

    // Flatten the accounts into one structure
    $scope.data = trust.accounts.reduce((acc, account) => {
      account.clients.forEach(client => {
        client.trustAccount = {
          id: account.id,
          label: account.label
        };
        client.data = {
          accounting: {},
          amounts: {}
        };
        acc.clients.push(client);
      });
      return acc;
    }, {
      clients: []
    });
    $scope.references = $scope.data.clients.some(c => c.matters.some(m => m.matter.reference));
    $scope.clientReferences = $scope.data.clients.some(c => c.client.reference);
    try {
      $scope.data.clients.forEach(client => {
        if (!client.client.billing.billClient) {
          client.matters.forEach(matter => {
            matter.evergreen = matter.matter.billing.evergreen;
            if (matter.evergreen) {
              matter.replenish = Math.max(0, matter.evergreen - matter.balance);
            }
          });
          client.evergreen = client.matters.reduce((sum, m) => sum + (m.evergreen || 0), 0);
          client.replenish = client.matters.reduce((sum, m) => sum + (m.replenish || 0), 0);
        } else {
          client.evergreen = client.client.billing.evergreen;
          if (client.evergreen) {
            client.replenish = Math.max(0, client.evergreen - client.balance);
          }
        }
      });
    } catch (err) {
      sentryService.captureException(err, {
        report: 'trust'
      });
    }
  }
  function mergeWip() {
    if ($scope.loading || $scope.loadingWip || !wipReport || !$scope.data) return;
    wipReport.clients.forEach(client => {
      const existingClient = $scope.data.clients.find(c => c.client.id === client.client.id);
      if (existingClient) {
        addToTrust(existingClient, client);
        client.matters.forEach(matter => {
          const existingMatter = existingClient.matters.find(m => m.matter.id === matter.matter.id);
          if (existingMatter) {
            addToTrust(existingMatter, matter);
          }
        });
      }
    });

    // Due includes the receivables balance, which only the WIP call carries
    $scope.data.clients.forEach(client => {
      if (!client.client.billing?.billClient) {
        client.matters.forEach(matter => {
          matter.due = (matter.replenish || 0) + (matter.data?.accounting?.balance || 0);
        });
        client.due = client.matters.reduce((sum, m) => sum + (m.due || 0), 0);
      } else {
        client.due = (client.replenish || 0) + (client.data?.accounting?.balance || 0);
      }
    });
    $scope.wipLoaded = true;
    calculateTotals();
  }
  function addToTrust(trust, data) {
    trust.data = data.data;
    if (trust.data.amounts.total) {
      trust.wipRatio = Math.min(Math.round(trust.balance * 100 / trust.data.amounts.total), 100);
    }
  }

  // matterId is optional
  $scope.goToSummary = function (client, matter) {
    if (!matter && !client.billing.billClient) {
      alerts.warning(`Clients is set up for ${$scope.me.terms.Matter} Accounting, so can only show transactions at ${$scope.me.terms.matter} level`);
      return;
    }
    $state.go("reports.trust-detail", {
      clientId: client.id,
      matterId: matter ? matter.id : null,
      return: "reports.trust",
      report: `Trust Statement`
    });
  };
  $scope.$watch("search", () => {
    if (!$scope.data || !$scope.data.filteredClients) return; // Not loaded yet

    // Wait for DOM update because filteredClients is updated there
    $timeout(() => {
      // Reset total
      objectNumberManipulator.resetValues($scope.data.total);
      // Update sums
      $scope.data.filteredClients.forEach(fc => {
        objectNumberManipulator.sumValues($scope.data.total, fc.data);
      });
    });
  });
}]);